import React from 'react';
import { DataGridColumn } from '@amzn/katal-components/es/data-grid';
import { LIST_USERS_TABLE } from 'src/self-service/constants/SelfServiceConstants';
import { UserDetails } from 'src/state/slice/models/CaseLifecycleTypes';
import { renderJsx } from 'src/utilities/PageLayout';
import { ActionColumnFormatter } from '../formatters/ActionColumnFormatter';
import { UI_CLIENTS } from 'src/constants/GlobalConstants';

export function getColumnsConfig(onDeleteUser: Function) {
  function formatActionColumn(rowIndex: number, rowData: UserDetails) {
    return (
      <ActionColumnFormatter
        onDeleteUser={onDeleteUser}
        userDetails={rowData}
      />
    );
  }
  const columnsConfig: Array<DataGridColumn> = [
    {
      headerName: LIST_USERS_TABLE.USER_ID_COLUMN_HEADER,
      field: 'userId',
      sortable: true,
    },
    {
      headerName: LIST_USERS_TABLE.USER_NAME_COLUMN_HEADER,
      field: 'fullName',
      sortable: true,
    },
    {
      headerName: LIST_USERS_TABLE.EMAIL_ID_COLUMN_HEADER,
      field: 'primaryEmail',
      sortable: true,
    },
    {
      headerName: LIST_USERS_TABLE.ROLE_COLUMN_HEADER,
      field: 'role',
      sortable: true,
    },
    {
      headerName: LIST_USERS_TABLE.ACTIONS_COLUMN_HEADER,
      renderCustomContent: renderJsx(formatActionColumn),
    },
  ];
  return columnsConfig;
}
